import * as React from 'react';
import { Layout } from '../../components/Layout';
import { DataTable } from '../../components/DataTable';
import { RouteModal } from '../../components/RouteModal';
import template from './DataTemplate';
import { useGetAdsQuery } from '../../../services/gmoOfferwallApi';
import AddForm from './AddForm';
import EditForm from './EditForm';

export function OfferwallPage() {
  const { data = [], isLoading, error, isError } = useGetAdsQuery();

  return (
    <Layout title={'オファーウォール管理'}>
      <DataTable
        title={'オファーウォール管理'}
        data={data}
        loading={isLoading}
        error={error}
        isError={isError}
        template={template}
        noSearchPanel={true}
      />
      <RouteModal addForm={<AddForm />} editForm={<EditForm />} />
    </Layout>
  );
}

export default OfferwallPage;
